export default {"src":"/_next/static/media/heartHand.1f75bf4a.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};